import type {
  ListDocumentosAlunoUseCase, ListDocumentoTiposUseCase,
  ListRequerimentosAlunoUseCase, ListProtocolosAlunoUseCase,
  ListObservacoesAlunoUseCase, CreateObservacaoAlunoUseCase,
} from '@/application/port/in/PerfilAlunoTabsUseCase';
import type { DocumentoGateway } from '@/application/port/out/DocumentoGateway';
import type { RequerimentoGateway } from '@/application/port/out/RequerimentoGateway';
import type { ProtocoloGateway } from '@/application/port/out/ProtocoloGateway';
import type { CreateObservacaoCommand, ObservacaoAlunoGateway } from '@/application/port/out/ObservacaoAlunoGateway';
import type { Documento, DocumentoTipo } from '@/domain/model/Documento';
import type { Requerimento } from '@/domain/model/Requerimento';
import type { Protocolo } from '@/domain/model/Protocolo';
import type { ObservacaoAluno } from '@/domain/model/ObservacaoAluno';

export class ListDocumentosAlunoUseCaseImpl implements ListDocumentosAlunoUseCase {
  constructor(private readonly gw: DocumentoGateway) {}
  execute(alunoId: string): Promise<Documento[]> { return this.gw.listByAluno(alunoId); }
}
export class ListDocumentoTiposUseCaseImpl implements ListDocumentoTiposUseCase {
  constructor(private readonly gw: DocumentoGateway) {}
  execute(): Promise<DocumentoTipo[]> { return this.gw.listTipos(); }
}
export class ListRequerimentosAlunoUseCaseImpl implements ListRequerimentosAlunoUseCase {
  constructor(private readonly gw: RequerimentoGateway) {}
  execute(alunoId: string): Promise<Requerimento[]> { return this.gw.listByAluno(alunoId); }
}
export class ListProtocolosAlunoUseCaseImpl implements ListProtocolosAlunoUseCase {
  constructor(private readonly gw: ProtocoloGateway) {}
  execute(alunoId: string): Promise<Protocolo[]> { return this.gw.listByAluno(alunoId); }
}
export class ListObservacoesAlunoUseCaseImpl implements ListObservacoesAlunoUseCase {
  constructor(private readonly gw: ObservacaoAlunoGateway) {}
  execute(alunoId: string): Promise<ObservacaoAluno[]> { return this.gw.listByAluno(alunoId); }
}
export class CreateObservacaoAlunoUseCaseImpl implements CreateObservacaoAlunoUseCase {
  constructor(private readonly gw: ObservacaoAlunoGateway) {}
  execute(c: CreateObservacaoCommand): Promise<ObservacaoAluno> { return this.gw.create(c); }
}
